/* eslint-disable prefer-const */
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { AppErrors, NotFoundError } from '@fitness-force/errors';
import {
  WaiverMasterResponseList,
  SubscriptionSignUpOrderSummaryBillingDateResponse, 
  GetOrderStatusOfQuotation
  } from '@fitness-force/models';
import { catchError, map, Observable, throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SubscriptionSignupByUuidService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  httpPatchOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json-patch+json',
    })
  };

  httpOptionsPlainText = {
    headers: new HttpHeaders({
      'Content-Type': 'text/plain',
    })
  };

  constructor(private http: HttpClient) {
  }


  GetOrderDetails(BASE_URL: string, company_uuid: string, tenant_uuid: string, UUID: string): Observable<GetOrderStatusOfQuotation> {
    let url: string = BASE_URL + CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.GET_ORDERDETAILS.replace('{sigup_sts_uuid}', UUID).replace('{company_uuid}', company_uuid).replace('{tenant_uuid}', tenant_uuid);
    return this.getRequest(url);
  }

  GetOrderSubscriptionStatus(BASE_URL: string, company_uuid: string, tenant_uuid: string, UUID: string): Observable<GetOrderStatusOfQuotation> {
    let url: string = BASE_URL + CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.GET_ORDERDETAILS.replace('{sigup_sts_uuid}', UUID).replace('{company_uuid}', company_uuid).replace('{tenant_uuid}', tenant_uuid);
    return this.getRequest(url);
  }

  GetOrderSummaryPaymentTimeLine(BASE_URL: string, UUID: string): Observable<SubscriptionSignUpOrderSummaryBillingDateResponse> {
    let url: string = BASE_URL + CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.GET_ORDERSUMMARYBILLINGOCCURENCE.replace('{sigup_sts_uuid}', UUID);
    return this.getRequest(url);
  }

  GetWaivers(BASE_URL: string, company_uuid: string, tenant_uuid: string, UUID: string): Observable<WaiverMasterResponseList> {
    let url: string = BASE_URL + CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.GET_WAIVERS.replace('{sigup_sts_uuid}', UUID).replace('{company_uuid}', company_uuid).replace('{tenant_uuid}', tenant_uuid);
    return this.getRequest(url);
  }

  GetClientMandatoryField(BASE_URL: string, UUID: string): Observable<string[]> {
    let url: string = BASE_URL + CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.GET_CLIENT_MANDATORYFIELD.replace('{sigup_sts_uuid}', UUID);
    return this.getRequest(url);
  }

  patchRequest(url: string, body: any) {
    return this.http.patch(url, body, this.httpPatchOptions).pipe(
      map((res: any) => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  postRequest(url: string, body: any) {
    return this.http.post(url, body, this.httpOptions).pipe(
      map((res: any) => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getRequest(url: string) {
    return this.http.get(url, this.httpOptions).pipe(
      map((res: any) => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getRequestWithParams(url: string, allparams: any) {
    let parsedParams = new HttpParams()
    allparams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });
    return this.http.get(url, {
      headers: this.httpOptions.headers, params: parsedParams
    }).pipe(
      map((res: any) => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getRequestForPlainText(url: string) {
    return this.http.get(url, this.httpOptionsPlainText).pipe(
      map((res: any) => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }
}
